import GridItem from './GridItem.vue';
import GridLayout from './GridLayout.vue';
import ResponsiveGridLayout from './ResponsiveGridLayout.vue';

const VueGridLayout = {
    ResponsiveGridLayout,
    GridLayout,
    GridItem
}

module.exports = VueGridLayout;



// WEBPACK FOOTER //
// ./src/index.js